// extracted by mini-css-extract-plugin
module.exports = {"FMTrans":"FMTrans_FMTrans__2Hd-U"};